import api from "../../../shared/services/api";

export async function listContas() {
  const response = await api.get("/whatsapp/meta/contas");
  return response.data?.data || [];
}

export async function conectarConta({ system_user_token, waba_id, phone_number_id }) {
  const response = await api.post("/whatsapp/meta/contas", {
    system_user_token,
    waba_id,
    phone_number_id,
  });
  return response.data?.conta;
}

export async function desconectarConta(id) {
  const response = await api.delete(`/whatsapp/meta/contas/${id}`);
  return response.data;
}
